import {
  manualLogSheetViewForPlace,
  manualLogSportForSportKey,
  type ManualLogSheetView,
  type ManualLogSport,
} from "@/app/_components/companion/manual-log-state";

export function manualLogSportForConditionSport(
  sport: string | null | undefined,
): ManualLogSport {
  return manualLogSportForSportKey(sport) ?? "coastal";
}

export function conditionManualLogSheetView({
  placeSlug,
  placeLabel,
  sport,
  now,
  timeZone,
}: {
  placeSlug: string;
  placeLabel: string;
  sport: string;
  now?: Date;
  timeZone?: string;
}): ManualLogSheetView {
  return manualLogSheetViewForPlace({
    placeSlug,
    placeLabel,
    defaultSport: manualLogSportForConditionSport(sport),
    now,
    timeZone,
  });
}
